<script setup lang="ts">
   import { useAuth0 } from '@auth0/auth0-vue';

   const { isAuthenticated, loginWithRedirect, isLoading } = useAuth0() ?? {};

   /**
    * Gets the login search param from the url to set custom Auth0 "ext-portal" authorization param
    */
   function login() {
      const urlParams = new URLSearchParams(location.search);
      const portal = urlParams.get('login') || 'ipapolo';
      loginWithRedirect({
         authorizationParams: {
            'ext-portal': portal,
            redirect_uri: window.location.origin + '/lms',
         },
      });
   }
</script>

<template>
   <button
      v-if="!isAuthenticated && !isLoading"
      @click="login"
      class="flex items-center justify-center border border-white bg-brand-title px-7 py-3 uppercase text-white">
      Learner Portal
   </button>
</template>

<style scoped></style>
